export default {
  key: '',
  title: '',
  params: {},
  data: null,
  tableRowId: null,
};
